import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getCategories } from "../../api";
import ProductBoard from "./Products";
import ProductCatalog from "./ProductCatalog";

const ProductCategoryPage = () => {
  const { category: categoryParam } = useParams(); // en_name.toLowerCase() 값

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const res = await getCategories();
        setCategories(res.data.results ?? res.data);
        setLoading(false);
      } catch (err) {
        setError("카테고리 정보를 불러오는데 실패했습니다.");
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  if (loading) return <div className="loading">불러오는 중...</div>;
  if (error) return <div className="error">{error}</div>;

  const currentCategory = categories.find(
    (c) => c.en_name.toLowerCase() === categoryParam
  );

  if (!currentCategory) {
    return <div className="error">카테고리를 찾을 수 없습니다.</div>;
  }

  // order가 같은 카테고리끼리 같은 사업부로 취급
  const siblingCategories = categories.filter((c) => c.order === currentCategory.order);

  return currentCategory.display_type === "catalog" ? (
    <ProductCatalog category={currentCategory} siblings={siblingCategories} />
  ) : (
    <ProductBoard category={currentCategory} siblings={siblingCategories} />
  );
};

export default ProductCategoryPage;